import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchContract, generateContractPdfPreview } from "../../duck/id";
import { postRemote } from "../../duck/remote";
import { submitContract } from "../../duck/id";
import { Button, Segment } from "semantic-ui-react";
import {
  BankInfo,
  Confirmation,
  Footer,
  Header,
  Images,
  Intro,
  PaymentWarning,
  PdfPreview,
  RemoteSigning,
  RenterInfo,
  Signatures,
  Socials,
  TextSections,
} from "./components";
import { Warning } from "../../components";
import encrypt from "../../../../../helpers/encrypt";
import { rentersValid } from "../../helpers/renterSchema";

class Preview extends Component {
  state = {
    achSignature: null,
    achAccepted: false,
    accepted: false,
    bankAccountNumber: "",
    bankAccountNumberConfirmed: "",
    bankName: "",
    bankRoutingNumber: "",
    bankStartDate: null,
    coRenterSsn: "",
    docsValid: false,
    fontFamily: "Cedarville Cursive",
    isChecking: true,
    remote: false,
    renterSsn: "",
    signatures: [],
    signaturesComplete: false,
    showConfirm: false,
  };

  componentDidMount = () => {
    const {
      coRenter,
      renter,
      // voidedCheck,
    } = this.props;

    let docsValid = false;

    let docsToValidate = [
      this.props.driversLicense,
      this.props.proofOfIncome,
      this.props.proofOfResidence,
      // voidedCheck,
    ];

    if (coRenter) {
      docsToValidate.push(
        coRenter.drivers_license_image,
        coRenter.proof_of_income_image,
        coRenter.proof_of_residence_image
      );
    }

    if (!docsToValidate.includes(null)) {
      docsValid = true;
    }

    this.setState({ docsValid });

    if (
      this.props.id &&
      docsValid &&
      rentersValid(this.props.renter, this.props.coRenter) &&
      this.props.term &&
      this.props.payment &&
      this.props.coisGood
    ) {
      this.props.dispatch(generateContractPdfPreview(this.props.id));
    }

    if (this.props.remoteCode) {
      this.setState({
        remote: true,
      });
    }
  };

  componentDidUpdate = (prevProps) => {
    if (prevProps.remoteCode !== this.props.remoteCode) {
      this.setState({
        remote: this.props.remoteCode ? true : false,
      });
    }
  };

  handleBankingChange = (e) =>
    this.setState({ [e.target.name]: e.target.value });

  handleRemoteChange = (remote) => this.setState({ remote });

  handleSocialChange = (e) =>
    this.setState({ [e.target.name]: e.target.value });

  onRemoteSubmit = (e) => {
    e.preventDefault();

    this.props.dispatch(postRemote(this.props.id));
  };

  setAccepted = (e) => {
    e.preventDefault();
    this.setState({ accepted: true });
  };
  setSigsComplete = (signaturesComplete) =>
    this.setState({
      signatures: [],
      signaturesComplete,
    });
  setSignatures = (signatures) =>
    this.setState({
      signatures,
      signaturesComplete: true,
    });
  toggleConfirm = (e) => {
    e ? e.preventDefault() : null;
    this.setState({
      accepted: false,
      showConfirm: !this.state.showConfirm,
    });
  };

  setAchSignature = (achSignature) => {
    this.setState({ achSignature });
  };

  onSubmit = (e) => {
    const formData = new FormData();
    const achFormData = new FormData();
    const windmillData = encrypt(this.state.renterSsn);

    formData.append("contract_id", this.props.id);
    formData.append("windmill", windmillData.content);
    formData.append("windmill_iv", windmillData.iv);
    formData.append("account_number", this.state.bankAccountNumber);
    formData.append("requested_start_date", this.state.bankStartDate);
    formData.append("routing_number", this.state.bankRoutingNumber);
    formData.append("bank_name", this.state.bankName);
    formData.append("is_checking_account", this.state.isChecking);

    // DO STUFF FOR ACH SIGNATURE
    achFormData.append("contract_id", this.props.id);
    achFormData.append("bank_name", this.state.bankName);
    achFormData.append("is_checking_account", this.state.isChecking);
    // achFormData.append("ach_agreement_signature", this.state.achSignature);
    achFormData.append("font_family", this.state.fontFamily.replace(/\s/g, ""));
    achFormData.append("requested_start_date", this.state.bankStartDate);
    achFormData.append("account_number", this.state.bankAccountNumber);
    achFormData.append("routing_number", this.state.bankRoutingNumber);

    if (this.props.coRenter) {
      const turbineData = encrypt(this.state.coRenterSsn);
      formData.append("turbine", turbineData.content);
      formData.append("turbine_iv", turbineData.iv);
    }

    // this.state.signatures.forEach((sig) => {
    //   formData.append(`${sig.type}_signature`, sig.image);
    // });

    formData.append("font_family", this.state.fontFamily.replace(/\s/g, ""));

    this.props.dispatch(submitContract(formData, achFormData));
  };

  render() {
    const { remote } = this.state;
    const { coRenter, coisGood, renter } = this.props;

    const submitDisabled = () => {
      if (
        this.state.achAccepted &&
        this.state.bankName &&
        this.state.bankAccountNumber.length > 3 &&
        this.state.bankAccountNumberConfirmed ===
          this.state.bankAccountNumber &&
        this.state.bankRoutingNumber.length === 9 &&
        this.state.bankStartDate &&
        this.state.renterSsn.length === 9
      ) {
        if (this.props.coRenter) {
          if (this.state.coRenterSsn.length === 9) {
            return false;
          } else {
            return true;
          }
        }

        return false;
      }

      return true;
    };

    if (!rentersValid(renter, coRenter)) {
      return (
        <Warning
          color="yellow"
          icon="ban"
          subheader="Renter info is not complete"
          header="Hold Up!"
          step="renter"
        />
      );
    }

    if (!this.props.id || !this.props.term) {
      return (
        <Warning
          color="yellow"
          icon="ban"
          subheader={
            !this.props.id
              ? `This contract hasn't been created yet.`
              : `This contract doesn't have a term selected`
          }
          header="Hold Up!"
          step="term"
          showButton={!this.props.id ? false : true}
        />
      );
    }

    if (!this.state.docsValid) {
      return (
        <Warning
          color="yellow"
          icon="ban"
          subheader="Required documents are missing for this contract"
          header="Hold Up!"
          step="documents"
        />
      );
    }

    if (!coisGood) {
      return (
        <Warning
          color="yellow"
          icon="ban"
          header="Hold Up!"
          subheader="COI not in compliance"
          showButton={false}
        />
      );
    }

    if (!this.props.payment) {
      return (
        <Warning
          color="yellow"
          icon="ban"
          subheader="This contract hasn't been paid for"
          header="Hold Up!"
          step="payment"
        />
      );
    }

    if (this.state.showConfirm) {
      return (
        <Confirmation
          accepted={this.state.accepted}
          accountNumber={this.state.bankAccountNumber}
          cashTotal={this.props.term.cash_total}
          dealer={this.props.dealer}
          months={this.props.term.term}
          onClose={this.toggleConfirm}
          onSubmit={this.onSubmit}
          routingNumber={this.state.bankRoutingNumber}
          setAccepted={this.setAccepted}
          startDate={this.state.bankStartDate}
          totalMonthlyPayment={this.props.term.total_monthly_payment}
        />
      );
    }

    return (
      <div id="contractPdf">
        <Intro />
        <Segment padded>
          {!this.props.loading && <PdfPreview pdf={this.props.pdfFilename} />}
          <RemoteSigning
            code={this.props.remoteCode}
            email={this.props.renterEmail}
            onChange={this.handleRemoteChange}
            onSubmit={this.onRemoteSubmit}
            remote={this.state.remote}
          />
          {!remote && (
            <Socials
              coRenter={this.props.coRenterName}
              coRenterSsn={this.state.coRenterSsn}
              onChange={this.handleSocialChange}
              renter={this.props.renterName}
              renterSsn={this.state.renterSsn}
            />
          )}
          {!remote && (
            <BankInfo
              accountNumber={this.state.bankAccountNumber}
              accountNumberConfirmed={this.state.bankAccountNumberConfirmed}
              achAccepted={this.state.achAccepted}
              onAchAcceptChange={(e, d) =>
                this.setState({ achAccepted: d.checked })
              }
              onChange={this.handleBankingChange}
              routingNumber={this.state.bankRoutingNumber}
              startDate={this.state.bankStartDate}
              bankName={this.state.bankName}
              isChecking={this.state.isChecking}
              renter={this.props.renterName}
              setAchSignature={this.setAchSignature}
            />
          )}
          {!remote && (
            <Signatures
              coRenter={this.props.coRenterName}
              renter={this.props.renterName}
              setComplete={this.setSigsComplete}
              setSignatures={this.setSignatures}
              fontFamily={this.state.fontFamily}
              onFontChange={(e, d) => this.setState({ fontFamily: d.value })}
            />
          )}
          {!submitDisabled() && !remote && (
            <div style={{ margin: "20px 0", fontSize: "1.25em" }}>
              <p>
                <b>
                  By clicking generate contract, I confirm the above signature
                  represents the legal signature of {this.props.renterName}.
                </b>
              </p>
            </div>
          )}
          {!remote && (
            <Button
              content="Generate Contract"
              size="massive"
              style={{ margin: "40px 0 40px 0" }}
              fluid
              icon="check"
              labelPosition="right"
              onClick={this.toggleConfirm}
              positive
              disabled={submitDisabled()}
            />
          )}
        </Segment>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    coisGood: state.coisGood,
    coRenter: state.coRenter,
    coRenterName: state.coRenter
      ? `${state.coRenter.first_name} ${state.coRenter.last_name}`
      : null,
    dealer: state.dealer ? state.dealer.name : null,
    driversLicense: state.driversLicense,
    loading: state.loading,
    pdfFilename: state.pdfFilename,
    proofOfIncome: state.proofOfIncome,
    proofOfResidence: state.proofOfResidence,
    remoteCode: state.remoteCode,
    renter: state.renter,
    renterName: `${state.renter.first_name} ${state.renter.last_name}`,
    renterEmail: state.renter.email,
    id: state.id,
    payment: state.payment,
    term: state.term.selected,
    // voidedCheck: state.voidedCheck,
  };
}

export default connect(mapStateToProps)(Preview);
